import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    ponenumber: "",
    subject: "",
    fullmessage: "",
  });

  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    Object.keys(formData).forEach((key) => {
      payload.append(key, formData[key]);
    });

    try {
      const res = await fetch(
        "/prosapiens-cms/public/api/submitpostcontactreq",
        {
          method: "POST",
          body: payload,
        }
      );

      if (!res.ok) {
        throw new Error("Failed to submit form");
      }

      setSuccessMessage("✅ Message sent successfully!");
      setFormData({
        full_name: "",
        email: "",
        ponenumber: "",
        subject: "",
        fullmessage: "",
      });
    } catch (err) {
      console.error(err);
      setSuccessMessage("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <section className="contact-us">
        <div className="overlay container">
          <div className="hero-text"></div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact">
            {/* Left Column */}
            <div className="contact-info">
              <h2>
                Let’s Connect and Build the
                <br />
                Future of Work
              </h2>
              <p>
                Have a question, need support, or ready to hire? Whether you’re
                a company or a candidate, we’d love to hear from you. Reach out
                — we’re just a message away.
              </p>

              <div className="icon-line">
                <i className="fas fa-map-marker-alt"></i>
                <span>
                  RAM SVR, Plot No 4/2, Sector 1, Madhapur, HUDA Techno Enclave,
                  HITEC City, Hyderabad, Telangana- 500081
                </span>
              </div>
              <div className="icon-line">
                <i className="fas fa-phone-alt"></i>
                <span>+91 9568002281</span>
              </div>
              <div className="icon-line">
                <i className="fas fa-envelope"></i>
                <span>info@prosapiens.in</span>
              </div>
            </div>

            {/* Right Column */}
            <div className="contact-form">
              <h3>Get in touch</h3>
              <form onSubmit={handleSubmit}>
                <label>Full Name *</label>
                <input
                  type="text"
                  name="full_name"
                  value={formData.full_name}
                  onChange={handleChange}
                  required
                />

                <label>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label>Phone</label>
                <input
                  type="tel"
                  name="ponenumber"
                  value={formData.ponenumber}
                  onChange={handleChange}
                />

                <label>Subject *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />

                <label>Message *</label>
                <textarea
                  name="fullmessage"
                  rows="5"
                  value={formData.fullmessage}
                  onChange={handleChange}
                  required
                ></textarea>

                <button type="submit">SUBMIT</button>

                {successMessage && (
                  <p
                    style={{
                      marginTop: "10px",
                      color: successMessage.startsWith("✅") ? "green" : "red",
                    }}
                  >
                    {successMessage}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
